//
//
//
//
//
//

export default {
  name: 'app',
  mounted () {
    if (this.$route.path === '/deposit3' || this.$route.path === '/bankcard' || this.$route.path === '/usdt3' || this.$route.path === '/usdt4') {
      document.body.classList.add('themed')
      if (sessionStorage.getItem('theme') === null) {
        document.body.classList.add('light')
      } else {
        if (sessionStorage.getItem('theme') === '0') {
          document.body.classList.remove('dark')
          document.body.classList.add('light')
        } else {
          document.body.classList.remove('light')
          document.body.classList.add('dark')
        }
      }
    } else if (this.$route.path === '/deposit1' || this.$route.path === '/deposit2') {
      document.body.classList.remove('dark')
      document.body.classList.remove('light')
      document.body.classList.remove('themed')
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue